import { AxiosResponse } from 'axios';
import { API } from 'config';
import { LIST_BODY_RESULT } from 'models';
import {
  PARENT_PACKAGE_LIST_PARAMS_REQUEST,
  PARENT_PACKAGE_TYPE,
} from 'models/parent-package';
import { AppAPIInstance } from 'services/config-api';

export const getParentPackageListApi = async (
  params?: PARENT_PACKAGE_LIST_PARAMS_REQUEST
): Promise<AxiosResponse<{ data: LIST_BODY_RESULT<PARENT_PACKAGE_TYPE> }>> => {
  return await AppAPIInstance.get(API.CONCIERGE.PARENT_PACKAGES.DEFAULT, {
    params,
  });
};

export const exportParentPackageCSVApi = async (
  params?: Partial<PARENT_PACKAGE_LIST_PARAMS_REQUEST>
) => {
  return await AppAPIInstance.get(API.CONCIERGE.PARENT_PACKAGES.EXPORT_CSV, {
    params,
    responseType: 'blob',
  }).catch(async (e) => {
    return Promise.reject(
      JSON.parse((await e?.response?.data?.text()) || '{}')?.error
    );
  });
};
